var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vlt-loading"},[(!_vm.isEdge)?_c('img',{staticClass:"loading-ico",attrs:{"src":require("@/assets/icons/loading.svg"),"alt":"loader"}}):_c('div',{staticClass:"alternateLoader"})])}
var staticRenderFns = []

export { render, staticRenderFns }